import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import { FaMapMarkerAlt, FaEllipsisV } from 'react-icons/fa';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default markers in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MapEvents = ({ onLocationClick }) => {
  useMapEvents({
    click: (e) => {
      const { lat, lng } = e.latlng;
      onLocationClick(lat, lng);
    },
  });
  return null;
};

const InteractiveMap = ({ currentLocation, onLocationSelect }) => {
  const mapRef = useRef(null);

  const handleLocationClick = (latitude, longitude) => {
    onLocationSelect({ latitude, longitude });
  };

  // Default to San Mateo if no location is provided
  const defaultLocation = currentLocation || { latitude: 37.5665, longitude: -122.3255 };

  return (
    <motion.div 
      className="glass-card p-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <FaMapMarkerAlt className="text-xl text-blue-600" />
          <h3 className="text-lg font-semibold text-gray-800">Interactive Map</h3>
        </div>
        <button className="text-gray-400 hover:text-gray-600">
          <FaEllipsisV />
        </button>
      </div>
      
      <p className="text-sm text-gray-600 mb-4">
        Click anywhere to get weather for that location.
      </p>
      
      <div className="h-64 rounded-xl overflow-hidden">
        <MapContainer
          ref={mapRef}
          center={[defaultLocation.latitude, defaultLocation.longitude]}
          zoom={10}
          style={{ height: '100%', width: '100%' }}
          className="rounded-xl"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          
          <Marker position={[defaultLocation.latitude, defaultLocation.longitude]}>
            <Popup>
              <div className="text-center">
                <p className="font-semibold">San Mateo</p>
                <p className="text-sm text-gray-600">California, United States</p>
              </div>
            </Popup>
          </Marker>
          
          <MapEvents onLocationClick={handleLocationClick} />
        </MapContainer>
      </div>
      
      <div className="mt-2 text-xs text-gray-500">
        Leaflet | OpenStreetMap contributors
      </div>
    </motion.div>
  );
};

export default InteractiveMap;
